<template>
    <div>
        <app-nav></app-nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-2"></div>
                <main  role="main">
                    <h5 class="text-left my-3">Nouvel intérimaire</h5>
                    <div class="float-left col-10">
                        <p class="bg-danger" v-if="message">{{message.message}}</p>
                        <form v-on:submit.prevent class="interim-form">
                            <div class="form-group row">
                                <label for="salutation" class="col-5 control-label col-form-label-sm">Salutation</label>
                                <div class="col-7">
                                    <select v-model="salutation" class="form-control form-control-sm">
                                        <option disabled value="">Salutation</option>
                                        <option>Monsieur</option>
                                        <option>Madame</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" :class="{invalid: $v.nom.$error}">
                                <label for="nom" class="col-5 control-label col-form-label-sm"> Nom</label>
                                <div class="col-7">
                                    <input 
                                    autofocus 
                                    required 
                                    v-model.trim ="nom" 
                                    @blur="$v.nom.$touch()"
                                    placeholder="Nom" 
                                    autocomplete="off" 
                                    class="form-control form-control-sm" />
                                </div>
                            </div>
                            <div class="form-group row" :class="{invalid: $v.prenom.$error}">
                                <label for="prenom" class="col-5 control-label col-form-label-sm">Prénom</label>
                                <div class="col-7">
                                    <input 
                                    v-model.trim ="prenom"
                                    @blur="$v.prenom.$touch()"
                                    class="form-control form-control-sm" 
                                    placeholder="Prénom" 
                                    autocomplete="off" 
                                    type="text" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="adresse" class="col-5 control-label col-form-label-sm">Adresse</label>
                                <div class="col-7">
                                    <input v-model.trim ="adresse" name="adresse" type="text" class="form-control  form-control-sm" placeholder="Adresse"  />
                                </div>
                            </div>
                            <div class="form-group row" :class="{invalid: $v.email.$error}">
                                <label for="email" class="col-5 control-label col-form-label-sm"> Email</label>
                                <div class="col-7">
                                    <input 
                                    v-model.trim ="email"
                                    @blur="$v.email.$touch()"
                                    name="email"
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder="Email"/>
                                </div>
                            </div>
                            <div class="form-group row" :class="{invalid: $v.telephone.$error}">
                                <label for="telephone" class="col-5 control-label col-form-label-sm">Téléphone</label>
                                <div class="col-7">
                                    <input 
                                    name="telephone"
                                    type="text"
                                    class="form-control
                                    form-control-sm"
                                    placeholder="Num. téléphone"
                                    @blur="$v.telephone.$touch()"
                                    v-model.trim ="telephone" />
                                </div>
                            </div>
                            <div class="form-group row" :class="{invalid: $v.numss.$error}">
                                <label for="numss" class="col-5 control-label col-form-label-sm"> Num. de sécurité sociale</label>
                                <div class="col-7">
                                    <input 
                                    name="numss" 
                                    type="text" 
                                    class="form-control form-control-sm" 
                                    placeholder="0000000000000"
                                    @blur="$v.numss.$touch()"
                                    v-model.trim ="numss" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="lieuNaiss" class="col-5 control-label col-form-label-sm">Lieu de naissance</label>
                                <div class="col-7">
                                    <input name="lieuNaiss" type="text" class="form-control form-control-sm" placeholder="Lieu de naissance" v-model.trim ="lieuNaiss" />
                                </div>
                            </div>                    
                            <div class="form-group row">
                                <label class="col-5 control-label col-form-label-sm"> Département de naissance</label>
                                <div class="col-7">
                                    <input name="deptNaiss" type="text" class="form-control form-control-sm" placeholder="" v-model.trim ="departementNaiss" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-5 control-label col-form-label-sm"> Date de naissance</label>
                                <div class="col-7">
                                    <input v-model="dateNaiss" name ="date_naiss" type="date"  class="form-control form-control-sm" >
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="nationalite" class="col-5 control-label col-form-label-sm">Nationalité</label>
                                <div class="col-7">
                                    <select v-model="nationalite" class="form-control form-control-sm">
                                        <option disabled value="">Nationalité</option>
                                        <option>France</option>
                                        <option>Italie</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <button class="btn btn-primary" type="submit" @click="addInterimaire">Valider</button>
                                <button class="btn btn-secondary ml-2" type="submit" @click="cancel">Annuler</button>
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, email, minLength, maxLength, numeric, helpers} from 'vuelidate/lib/validators'
    import router from '../../router'
    import AppNav from '../AppNav'
    import {
        CREATE_INTERIMAIRE,
        ALL_INTERIMS
    } from '../../constants/interim'
  const alpha = helpers.regex('alpha', /^[a-zA-Zéèôê]*$/)
  export default {
    name: 'interimaire-new',
    components: {
      AppNav,
    },
    data() {
      return {
        nom: "",
        prenom: "",
        numss: "",
        telephone: "",
        email: "",
        adresse: "",
        salutation: "",
        lieuNaiss: "",
        dateNaiss: null,
        departementNaiss: '',
        nationalite: '',
        message: ''
      }
    },
    validations: {
      email: {
        required,
        email
      },
      nom: {
        required,
        alpha,
        minLength: minLength(3)
      },
      prenom: {
        required,
        alpha,
        minLength: minLength(2)
      },
      numss: {
        required,
        numeric,
        minLength: minLength(13),
        maxLength: maxLength(13)
      },
      telephone: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10)
      }
    },
    methods: {
        cancel () {
            router.push({name: 'Interimaires' })
        },
         addInterimaire() {
            const nom = this.nom
            const prenom = this.prenom
            const email = this.email
            const adresse = this.adresse
            const telephone = this.telephone
            const salutation = this.salutation
            const numss = this.numss
            const lieuNaiss = this.lieuNaiss
            const dateNaiss  = this.dateNaiss
            const departementNaiss = this.departementNaiss
            const nationalite = this.nationalite
            this.$apollo.mutate({
                mutation: CREATE_INTERIMAIRE,
                variables: {
                    nom: this.nom,
                    prenom: this.prenom,
                    email: this.email,
                    adresse: this.adresse,
                    telephone: this.telephone,
                    salutation: this.salutation,
                    numss: this.numss,
                    lieuNaiss: this.lieuNaiss,
                    dateNaiss: this.dateNaiss,
                    departementNaiss: this.departementNaiss,
                    nationalite: this.nationalite,
                    actif: true,
                },
                 refetchQueries: [{
                query: ALL_INTERIMS
            }]     
        }).then((data) => {    
          router.push({name: 'Interimaires'})
        }).catch((error) => {
            console.error(error)
            this.message = error
            // We restore the initial user input
            this.nom = nom
            this.prenom = prenom
            this.email = email
            this.adresse= adresse
            this.telephone = telephone
            this.salutation = salutation
            this.numss  = numss
            this.lieuNaiss= lieuNaiss
            this.dateNaiss  = dateNaiss
            this.departementNaiss = departementNaiss
            this.nationalite = nationalite
        })
      }
    }
  }
</script>
<style scoped>
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}
/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.interim-form{
    padding-bottom: 60px;
    padding-top: 30px;
}

label {
    width: 25rem;
}

.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}

.invalid label {
  color: red;
}
</style>



// WEBPACK FOOTER //
// interimNew.vue?5cd7134f